import styled from "styled-components";

export const CommonTabWrap = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "orientation",
})<{
  orientation?: "vertical" | "horizontal";
}>`
  display: flex;
  align-items: flex-start;
  flex-direction: ${({ orientation }) =>
    orientation === "vertical" ? "column" : "row"};
  @media (max-width: 1199px) {
    flex-direction: column;
  }
  .tab_list_wrap_outer {
    overflow: hidden;
    display: flex;
    width: 100%;
    max-width: 490px;
    flex-direction: ${({ orientation }) =>
      orientation === "vertical" ? "row" : "column"};
    gap: 20px;
    @media (max-width: 1199px) {
      max-width: 100%;
      flex-direction: row;
      overflow: hidden;
    }
    .tabListWrap {
      display: flex;
      max-width: 414px;
      flex: 1 1 auto;
      -webkit-flex: 1 1 auto;
      -ms-flex: 1 1 auto;
      white-space: nowrap;
      scrollbar-width: none;
      overflow-x: auto;
      overflow-y: hidden;
      margin-right: auto;
      align-items: center;
      gap: 20px;
      flex-direction: ${({ orientation }) =>
        orientation === "vertical" ? "row" : "column"};

      @media (max-width: 1199px) {
        max-width: 100%;
        flex-direction: row;
        position: relative;
      }
      .tab_btn {
        position: relative;
        flex-shrink: 0;
        min-width: 414px;
        min-height: 102px;
        background: #ffffff;
        padding: 30px 29px;
        align-items: center;
        justify-content: flex-start;
        border: 1px solid rgba(39, 44, 101, 0.2);
        border-radius: 20px;
        font-family: "Inter";
        font-weight: 500;
        font-size: 22px;
        text-transform: capitalize;
        color: #000000;
        transition: 0.4s ease-in-out;
        outline: none !important;
        @media (max-width: 1199px) {
          min-width: 250px;
          padding: 25px 20px;
          min-height: auto;
          border-radius: 10px;
          font-size: 18px;
        }
        @media (max-width: 899px) {
          padding: 15px;
        }
        i {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          line-height: 0;
          margin-right: 15px;
        }
        &.active {
          background: #ffffff;
          border-color: #00baff;
          color: #ff1818;
          box-shadow: 25px 26px 84px rgba(255, 24, 24, 0.2);
        }
      }
    }
    .tabsnavigate_Btns {
      display: none;
      align-items: center;
      justify-content: center;
      margin: auto;
      color: #000000;
      @media (max-width: 1199px) {
        display: flex;
      }
      @media (max-width: 599px) {
        display: none;
      }
      &.prevBtn {
        transform: rotate(-90deg);
      }
      &.nextBtn {
        transform: rotate(90deg);
      }
      &.disableBtn {
        pointer-events: none;
        opacity: 0;
      }
      svg {
        /* width: 25px;
        height: 25px; */
      }
    }
  }
  .panel_list_wrap {
    position: relative;
    z-index: 2;
    height: auto;
    padding-left: 15px;
    max-width: calc(100% - 490px);
    width: 100%;
    @media (max-width: 1199px) {
      max-width: 100%;
      padding-left: 0;
      padding-top: 20px;
    }
  }
`;

export const TabPanelStyled = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "orientation",
})<{
  orientation?: "vertical" | "horizontal";
}>`
  height: 100%;
`;
